









import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import _ from "lodash";
import {
  HsabExpenseCategory,
  HsabExpenseSubTypeResponse
} from "@/shared/types";
import { Moment } from "moment";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({})
export default class HsabExpensePayFromDisplay extends Vue {
  hsabExpenseStore = useHsabExpenseStore();
  hsabAccountsStore = useHsabAccountsStore();
  possiblePlans: string[] = [];
  possibleSubTypes: HsabExpenseSubTypeResponse[] = [];
  payFromHasHsaAndNotional = false;

  @Prop()
  currentDate: Moment;

  @Prop()
  currentCategory: HsabExpenseCategory;

  @Prop()
  currentType: string;

  @Prop()
  currentSubType: string;

  @Watch("currentCategory")
  onCategoryChanged () {
    this.calculateAndUpdatePayFrom();
  }

  @Watch("currentType")
  onTypeChanged () {
    this.calculateAndUpdatePayFrom();
  }

  @Watch("currentSubType")
  onSubTypeChanged () {
    this.calculateAndUpdatePayFrom();
  }

  @Watch("currentDate")
  onCurrentDateChanged () {
    this.calculateAndUpdatePayFrom();
  }

  created () {
    this.hsabAccountsStore.getHsabAccounts();
    this.hsabExpenseStore.loadExpenseCategories();
  }

  get requirementsLoaded () {
    return this.hsabAccountsStore.allHsabAccountsLoaded && this.hsabExpenseStore.isCategoryDataLoaded;
  }

  get showPayFrom () {
    const activePlanCount = _.filter(this.hsabAccountsStore.allHsabAccounts, x => x.isActive === true).length;
    return activePlanCount > 1;
  }

  get planListDisplay (): string[] {
    if (this.possiblePlans.length > 1 && this.possiblePlans.some(x => x === "HSA")) {
      this.payFromHasHsaAndNotional = true;
      return this.possiblePlans.filter(x => x !== "HSA");
    } else {
      this.payFromHasHsaAndNotional = false;
    }
    return this.possiblePlans;
  }


  get planListDisplayString () {
    return this.planListDisplay.join(", ");
  }

  get showHsaBackupAlert () {
    return this.payFromHasHsaAndNotional;
  }

  get backupAlertDisplay () {
    if (this.possiblePlans && this.possiblePlans.length === 2) {
      return "If funds from your " + this.possiblePlans.filter(x => x !== "HSA") + " aren't available, your HSA will be used.";
    }
    else if (this.possiblePlans && this.possiblePlans.length > 2) {
      return "If funds from your spending accounts aren't available, your HSA will be used.";
    }
    else return "";
  }

  calculateAndUpdatePayFrom () {
    this.possiblePlans = [];
    this.possibleSubTypes = [];

    const hasCategory = this.currentCategory !== undefined && this.currentCategory !== null && this.currentCategory !== HsabExpenseCategory.Unknown;
    const hasType = this.currentType !== undefined && this.currentType !== null && this.currentType !== "";
    const hasSubType = this.currentSubType !== undefined && this.currentSubType !== null && this.currentSubType !== "";

    if (hasCategory) {
      const types = this.hsabExpenseStore.getExpenseTypesAndSubtypesByCategory(this.currentCategory);

      if (hasType) {
        const type = types.find(x => x.expenseType === this.currentType);
        if (type) {
          if (hasSubType) {
            const subType = type.expenseSubTypes.find(x => x.subTypeName === this.currentSubType);
            if (subType) {
              this.possibleSubTypes = [ subType ];
            }
          } else {
            this.possibleSubTypes = type.expenseSubTypes;
          }
        }
      } else {
        _.forEach(types, t => {
          this.possibleSubTypes = _.concat(this.possibleSubTypes, t.expenseSubTypes);
        });
      }

      const plans = [];
      _.forEach(this.possibleSubTypes, x => {
        if (this.currentDate.isSameOrAfter(x.eligibleStartDate)) {
          _.forEach(x.planEligibility, e => {
            if (this.currentDate.isSameOrAfter(e.eligibleStartDate)) {
              plans.push(e.planDisplayName);
            }
          });
        }
      });

      this.possiblePlans = _.uniq(plans);
      this.$emit("change", this.planListDisplay);
    }
  }
}
